import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface ComiteActa {
  id?: number;
  cedula?: number;
  fecha_reunion: string | Date;
  hora_inicio: string;
  hora_finalizacion: string;
  lugar_reunion: string;
  nombre_comite?: string;
  numeroComite?: number;
  numeroActa?: number;
  empresa: string;
  vigencia_desde: string | Date;
  temas_tratados?: string;
  compromisos?: number;
  tipo_reunion: number;
  url_acta_pdf?: string | null;
  fecha_creacion?: string | Date;
  fecha_modificacion?: string | Date | null;
}

export interface ComiteActaResponse {
  message?: string;
  data?: ComiteActa | ComiteActa[];
  error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ComiteActaService {
  private apiUrl = `${environment.apiUrl}/api/comiteActa`;

  constructor(private http: HttpClient) {
  }

  /**
   * Obtener todas las actas de comité
   */
  getAll(): Observable<ComiteActa[]> {
    return this.http.get<any>(`${this.apiUrl}`).pipe(
      map((res) => (Array.isArray(res) ? res : (res?.data ?? [])))
    );
  }

  /**
   * Obtener acta por ID
   */
  getById(id: number): Observable<ComiteActa> {
    return this.http.get<ComiteActa>(`${this.apiUrl}/${id}`);
  }

  /**
   * Obtener actas por número de comité
   */
  getByNumeroComite(numeroComite: number): Observable<ComiteActa[]> {
    return this.http.get<any>(`${this.apiUrl}/numero/${numeroComite}`).pipe(
      map((res) => (Array.isArray(res?.data) ? res.data : (res?.data ?? [])))
    );
  }

  /**
   * Crear nueva acta de comité
   */
  create(acta: ComiteActa): Observable<ComiteActaResponse> {
    const url = `${this.apiUrl}`;
    console.log(`🚀 POST request to: ${url}`, acta);
    return this.http.post<ComiteActaResponse>(url, acta);
  }

  /**
   * Actualizar acta existente
   */
  update(id: number, numeroComite: number, acta: ComiteActa): Observable<ComiteActaResponse> {
    const url = `${this.apiUrl}/${id}`;
   // console.log(`🔄 PUT request to: ${url}`, acta);
    return this.http.put<ComiteActaResponse>(url, acta);
  }

  /**
   * Eliminar acta de comité
   */
  delete(id: number): Observable<ComiteActaResponse> {
    const url = `${this.apiUrl}/${id}`;
    //console.log(`🗑️ DELETE request to: ${url}`);
    return this.http.delete<ComiteActaResponse>(url);
  }

  /**
   * Subir PDF del acta
   */
  uploadPdf(id: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    const url = `${this.apiUrl}/${id}/pdf`;
    //console.log(`📤 Subiendo PDF para acta ID: ${id}`);
    return this.http.post<any>(url, formData);
  }

  /**
   * Obtener URL del PDF del acta
   */
  getPdfUrl(id: number): string {
    return `${this.apiUrl}/${id}/pdf`;
  }

  downloadPdfById(id: number): Observable<Blob> {
    const url = this.getPdfUrl(id);
    return this.http.get(url, {
      withCredentials: true,
      responseType: 'blob'
    });
  }

}
